import { render, staticRenderFns } from "./CreatePotentialApplicantControl.vue?vue&type=template&id=6c846913&"
import script from "./CreatePotentialApplicantControl.vue?vue&type=script&lang=js&"
export * from "./CreatePotentialApplicantControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports